import { OnlinePaymentsIntegration } from './integration/OnlinePaymentsIntegration';
import { OnlinePaymentsLoader } from './OnlinePaymentsPanel.loader';
import { OnlinePaymentsProviderDetails } from './providerDetails/OnlinePaymentsProviderDetails';

export const OnlinePaymentsPanel = (): JSX.Element => {
   return (
      <OnlinePaymentsLoader>
         {({ onlinePaymentsIntegrationConfiguration }) =>
            onlinePaymentsIntegrationConfiguration ? (
               <OnlinePaymentsProviderDetails
                  onlinePaymentsIntegrationConfiguration={onlinePaymentsIntegrationConfiguration}
               />
            ) : (
               <OnlinePaymentsIntegration />
            )
         }
      </OnlinePaymentsLoader>
   );
};
